import React, { useState, useEffect } from "react";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./Header.css";
import logoBlack from "../../assets/img/logo definitif noir.png";
import logoWhite from "../../assets/img/logo definitif blanc.png";
import { Mail, PhoneCall } from "lucide-react";
import IntlMessages from "../../intl/IntlMessages";
import {
  FaLanguage,
  FaTelegram,
  FaTiktok,
  FaWhatsapp,
} from "react-icons/fa";
import { useLocaleActionsContext } from "../../context/LocaleContextProvide";

function Header() {
  const { updateLocale } = useLocaleActionsContext();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShrunk, setIsShrunk] = useState(false);
  const [activeLink, setActiveLink] = useState("home");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Données pour les menus déroulants
  const services = [
    { title: <IntlMessages id="navigation.realEstate" />, path: "/vision/immobilier" },
    { title: <IntlMessages id="eventPlanning.title" />, path: "/vision/évènementiel" },
    { title: <IntlMessages id="expertise.itServices" />, path: "/vision/informatique" },
    { title: <IntlMessages id="expertise.networksTelecom" />, path: "/vision/telecom" },
    { title: <IntlMessages id="content.btp" />, path: "/vision/civilEngeneering" },
    { title: <IntlMessages id="expertise.socialPlatform" />, path: "/vision/socialPlatform" },
  ];

  const lang = [
    {
      title: "Français",
      value: {
        languageId: "francais",
        locale: "fr",
        name: <IntlMessages id="navigation.french" />,
        icon: "fr",
      },
      locale: {
        languageId: "francais",
        locale: "fr",
        name: <IntlMessages id="navigation.french" />,
        icon: "fr",
      },
    },
    {
      title: "English",
      value: {
        languageId: "english",
        locale: "en",
        name: <IntlMessages id="navigation.english" />,
        icon: "us",
      },
      locale: {
        languageId: "english",
        locale: "en",
        name: <IntlMessages id="navigation.english" />,
        icon: "us",
      },
    },
  ];

  const solutions = [
    { title: <IntlMessages id="navigation.software" />, path: "/solutions/mobile" },
    { title: <IntlMessages id="webDevelopment.webApps" />, path: "/solutions/web" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
        if (window.scrollY > 50) {
          setIsShrunk(true);
        } else {
          setIsShrunk(false);
        }
      } else {
        setIsScrolled(false);
        setIsShrunk(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const onUpdateActiveLink = (link) => {
    setActiveLink(link);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      <div className="top-header">
        <Container className="d-flex justify-content-between align-items-center">
          <div className="contact-infoH">
            <a href="mailto:estatiasci@gmail.com">
              <Mail className="me-2" />
              estatiasci@gmail.com
            </a>
            <a href="tel:+237698476609">
              <PhoneCall className="me-2" />
              +237 698 476 609
            </a>
            <a href="tel:+237620196116">
              <PhoneCall className="me-2" />
              +237 620 196 116
            </a>
          </div>
          <div className="social-links">
            <span className="testH">
              <IntlMessages id="navigation.followUs" />
            </span>

            <a
              href="https://t.me/+mEEGbI-6v91mMjY0"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link telegram"
            >
              <FaTelegram size={18} />
            </a>
            <a
              href="https://wa.me/237698476609"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link whatsapp"
            >
              <FaWhatsapp size={18} />
            </a>
            <a
              href="https://www.tiktok.com/@estatiasci?_t=ZS-8u5ROFr1Zq6&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link titkok custumBout"
            >
              <FaTiktok size={18} />
            </a>
          </div>
        </Container>
      </div>
      {/*Barre de menu*/}
      <Navbar
        className={`navbar-expand-lg fixed-top ${
          isScrolled ? "bg-dark" : "bg-transparent"
        }${isShrunk ? " shrink" : ""}`}
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand className="logo">
              {window.scrollY > 50 ? (
                <img
                  src={logoWhite}
                  alt="Logo-black Estatia-SCI"
                  height={isShrunk ? "50" : "80"}
                  className="d-inline-block align-top logo"
                />
              ) : (
                <img
                  src={logoBlack}
                  alt="Logo-white Estatia-SCI"
                  height={isShrunk ? "50" : "80"}
                  className="d-inline-block align-top logo"
                />
              )}
            </Navbar.Brand>
          </LinkContainer>

          <div
            className={`menu-toggle ${isMenuOpen ? "active" : ""}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div
            className={`nav-overlay ${isMenuOpen ? "show" : ""}`}
            onClick={toggleMenu}
          ></div>

          <Nav className={`ms-auto main-nav ${isMenuOpen ? "show" : ""}`}>
            <LinkContainer to="/">
              <Nav.Link
                className={`${activeLink === "home" ? "active" : ""}${
                  window.scrollY > 0 && " nav-link2"
                }`}
                onClick={() => onUpdateActiveLink("home")}
              >
                <IntlMessages id="navigation.home" />
                <span className="hover-effect"></span>
              </Nav.Link>
            </LinkContainer>

            <NavDropdown
              title={
                <span className={`${window.scrollY > 0 && " nav-link2"}`}>
                  <IntlMessages id="navigation.vision" />
                  <span className="hover-effect"></span>
                </span>
              }
              id="services-dropdown"
              className={activeLink === "quelquesServices" ? "active" : ""}
            >
              {services.map((service, index) => (
                <LinkContainer key={index} to={service.path}>
                  <NavDropdown.Item
                    onClick={() => onUpdateActiveLink("quelquesServices")}
                  >
                    {service.title}
                  </NavDropdown.Item>
                </LinkContainer>
              ))}
            </NavDropdown>

            <NavDropdown
              title={
                <span className={`${window.scrollY > 0 && " nav-link2"}`}>
                  <IntlMessages id="navigation.software" />
                  <span className="hover-effect"></span>
                </span>
              }
              id="solutions-dropdown"
              className={activeLink === "solutions" ? "active" : ""}
            >
              {solutions.map((solution, index) => (
                <LinkContainer key={index} to={solution.path}>
                  <NavDropdown.Item
                    onClick={() => onUpdateActiveLink("solutions")}
                  >
                    {solution.title}
                  </NavDropdown.Item>
                </LinkContainer>
              ))}
            </NavDropdown>

            <LinkContainer to="/services">
              <Nav.Link
                className={`${activeLink === "prices" ? "active" : ""}${
                  window.scrollY > 0 && " nav-link2"
                }`}
                onClick={() => onUpdateActiveLink("prices")}
              >
                <IntlMessages id="navigation.price" />
                <span className="hover-effect"></span>
              </Nav.Link>
            </LinkContainer>

            <LinkContainer to="/apropos">
              <Nav.Link
                className={`${activeLink === "apropos" ? "active" : ""}${
                  window.scrollY > 0 && " nav-link2"
                } nav-dropdown-title`}
                onClick={() => onUpdateActiveLink("apropos")}
              >
                <IntlMessages id="navigation.aboutUs" />
                <span className="hover-effect"></span>
              </Nav.Link>
            </LinkContainer>

            <LinkContainer to="/contact">
              <Nav.Link
                className="contact-button"
                onClick={() => onUpdateActiveLink("contact")}
              >
                <IntlMessages id="navigation.contact" />
              </Nav.Link>
            </LinkContainer>
            <NavDropdown
              title={
                <>
                  <span className={`${window.scrollY > 0 && " nav-link3"}`}>
                    <FaLanguage size={32} />
                  </span>
                </>
              }
              id="services-dropdown"
            >
              {lang.map((lang, index) => (
                <NavDropdown.Item
                  key={index}
                  onClick={() => updateLocale(lang.locale)}
                >
                  {lang.title}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
